export function setCustomAttribute<Type>(key: string, value?: Type | undefined, persist = false) {
  window?.newrelic?.setCustomAttribute(key, value, persist);
}
